// When a parent app embeds Elis in an iframe and drives autologin via
// `?auto_login_sso_provider_id=N`, multiple parents share the same Elis origin
// but map to different Rossum orgs/users. To keep their sessions from clashing
// in the shared `localStorage` we pin the provider id for THIS tab in
// `sessionStorage` (tab-scoped) and namespace the auth token key by it (see
// `token.ts`). A fresh tab re-derives the provider from its own URL, so the pin
// never leaks across tabs while the token itself stays in `localStorage` and
// survives restarts.

const PROVIDER_PIN_KEY = 'auto_login_sso_provider_id';

export const isIframeEmbedded = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    // Accessing `window.top` across origins can throw — which only happens when
    // we are framed by a different-origin parent.
    return true;
  }
};

/**
 * Pin the autologin SSO provider id for this tab when embedded via an iframe and
 * the parent supplied it. Run once at startup, before any auth token is read.
 */
export const initEmbeddedSsoSession = (): void => {
  if (!isIframeEmbedded()) {
    return;
  }

  const fromUrl = new URLSearchParams(window.location.search).get(
    PROVIDER_PIN_KEY
  );

  if (fromUrl) {
    sessionStorage.setItem(PROVIDER_PIN_KEY, fromUrl);
  }
};

export const getActiveSsoProviderId = (): string | null =>
  sessionStorage.getItem(PROVIDER_PIN_KEY);
